import { render, staticRenderFns } from "./BoardColumn.vue?vue&type=template&id=423460e9&"
import script from "./BoardColumn.vue?vue&type=script&lang=js&"
export * from "./BoardColumn.vue?vue&type=script&lang=js&"
import style0 from "./BoardColumn.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports